import { css } from "@emotion/react";

export const qrCodeWrapper = css`
  margin: 1rem auto 0.75rem auto;
  text-align: center;
  width: fit-content;
`;
